import React from 'react';
import Icon from "../workflow/Icon";
import {Handle, Position} from 'react-flow-renderer';
import UseGetterNodeValue from "./hooks/UseGetterNodeValue";
import {AlertTriangle} from "react-feather";
import {LookupSlug} from "../../config/Config";

function Component(node) {
    const {data} = node
    let label = UseGetterNodeValue(node, 'info', 'title', data.label)
    const TwoOutputComponentents = [
        LookupSlug
    ]


    return (
        <>
            {!data.is_entry && <Handle type="target" position={Position.Left}/>}
            <div className={`Component ${TwoOutputComponentents.includes(data.slug) ? "TwoOutputs " : ""}WorkFlow`}>
                {data.hasErrors && <AlertTriangle className="node-alert" />}
                <Icon className={data.slug} iconName={data.icon}/>
                <span className="Label">{label}</span>
            </div>
            {!TwoOutputComponentents.includes(data.slug) && <Handle type="source" position={Position.Right} id="a"/>}
            {TwoOutputComponentents.includes(data.slug) && <>
                <Handle type="source" position={Position.Right} id="yes" />
                <Handle type="source" position={Position.Right} id="no" />
            </>}
        </>
    );
}

export default Component